// Thin wrapper around authenticatedFetch. Mirrors Users/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/b2b-order-review';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try {
      const j = await resp.json();
      detail = typeof j.detail === 'string' ? j.detail : '';
    } catch { /* status alone is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}

export const reviewApi = {
  status: () => authenticatedFetch(`${BASE}/status`).then(jsonOrThrow),
  orders: ({ status, q, store, days, page }) => {
    const p = new URLSearchParams({ status, days, page });
    if (q) p.set('q', q);
    if (store) p.set('store', store);
    return authenticatedFetch(`${BASE}/orders?${p}`).then(jsonOrThrow);
  },
  order: (id) => authenticatedFetch(`${BASE}/orders/${id}`).then(jsonOrThrow),
  rerun: (id) => authenticatedFetch(`${BASE}/orders/${id}/rerun`, { method: 'POST' }).then(jsonOrThrow),
  releaseHold: (id) => authenticatedFetch(`${BASE}/orders/${id}/release-hold`, { method: 'POST' }).then(jsonOrThrow),
  cancelOrder: (id) => authenticatedFetch(`${BASE}/orders/${id}/cancel`, { method: 'POST' }).then(jsonOrThrow),
  markReviewed: (id) => authenticatedFetch(`${BASE}/orders/${id}/review`, { method: 'POST' }).then(jsonOrThrow),
};
